const buttonAlign = {
    init() {
        buttonAlign.create();
    },
    create() {
        $('.button-align-left, .button-align-center, .button-align-right').each(function() {
            var buttonClass = $(this).attr('class');
            var buttonAlignClass = buttonClass.match(/button-align-(left|center|right)/);

            if (buttonAlignClass) {
                var wrapClass = 'button-wrap-' + buttonAlignClass[1];
                $(this).wrap('<div class="' + wrapClass + '"></div>');
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    buttonAlign.init();
});